import React from 'react'
import { FlatList, ListRenderItemInfo } from 'react-native'
import ActionCard from 'components/molecules/ActionCard'
import { useAppSelector } from 'hooks/redux'
import useNavigation from 'hooks/useNavigation'
import { ContainerView, RenderView } from './styles'

const CONTACT_PHONE_KEY = 'qirapagos-server.settings.contactPhoneNumber'

interface IDataActionCards {
  icon: 'accountData' | 'newTransfer' | 'myContacts' | 'helpCenter' | 'debin'
  title: string
  onPress: () => void
}

const DEBIN_ENABLED_KEY = 'qirapagos-server.settings.debin_enabled'

const ActionCardList = () => {
  const { onNavigate } = useNavigation()
  const isDebinEnabled = useAppSelector(
    state => state.settings.data[DEBIN_ENABLED_KEY] === 'true'
  )
  const phoneNumber = useAppSelector(
    state => state.settings.data[CONTACT_PHONE_KEY] || ''
  )
  const normalizedPhone = (phoneNumber || '').replace(/\D/g, '')
  const whatsappLink = normalizedPhone ? 'https://wa.me/' + normalizedPhone : ''

  const debinOrWhatsappCard: IDataActionCards = isDebinEnabled
    ? {
        icon: 'debin',
        title: 'Pagos con DEBIN',
        onPress: () =>
          onNavigate('/content/your-account/debin', {
            title: 'Pagos con DEBIN',
            hasBackArrow: true
          })
      }
    : {
        icon: 'helpCenter',
        title: 'Contacto por WhatsApp',
        onPress: () => window.open(whatsappLink, '_blank')
      }

  const dataActionCards: IDataActionCards[] = [
    {
      icon: 'accountData',
      title: 'Datos de mi cuenta',
      onPress: () =>
        onNavigate('/content/your-account/details', {
          title: 'Datos de mi cuenta',
          hasBackArrow: true
        })
    },
    {
      icon: 'newTransfer',
      title: 'Nueva transferencia',
      onPress: () =>
        onNavigate('/content/your-account/new-transfer', {
          title: 'Nueva transferencia',
          hasBackArrow: true
        })
    },
    {
      icon: 'myContacts',
      title: 'Mis contactos',
      onPress: () =>
        onNavigate('/content/your-account/my-contacts', {
          title: 'Mis Contactos',
          hasBackArrow: true
        })
    },
    debinOrWhatsappCard
  ]

  const renderItem = ({ item }: ListRenderItemInfo<IDataActionCards>) => {
    return (
      <RenderView>
        <ActionCard
          icon={item.icon}
          title={item.title}
          onPress={item.onPress}
          height="100px"
          width="120px"
        />
      </RenderView>
    )
  }
  return (
    <ContainerView>
      <FlatList
        data={dataActionCards}
        renderItem={renderItem}
        contentContainerStyle={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-end'
        }}
      />
    </ContainerView>
  )
}

export default ActionCardList
